import computeClassName from '../../../../../../../../../utils/computeClassName';
//import { useUserContext } from '../../../../../../../ContextProvider/User';


export default function MyPartners({className}) {
  const computedClassName = computeClassName(className, '');

  return (
    <div className={computedClassName}>My Partners</div>
  );
}
